"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateQueryParams = void 0;
const react_1 = require("react");
const luxon_1 = require("luxon");
const consts_1 = require("../../consts");
const useSearchParams_1 = require("../useSearchParams");
const useDateQueryParams = (dateInput) => {
    const searchParams = (0, useSearchParams_1.useSearchParams)();
    const dateParamISOString = searchParams.get(consts_1.DATE_PARAM_NAME);
    const dateParam = dateParamISOString
        ? luxon_1.DateTime.fromISO(dateParamISOString)
        : null;
    const selectedDate = (0, react_1.useMemo)(() => {
        if (dateInput && dateInput.isValid) {
            return luxon_1.DateTime.now()
                .set({
                year: dateInput.year,
                month: dateInput.month,
                day: dateInput.day
            })
                .startOf('day');
        }
        else if (dateParam && dateParam.isValid) {
            return luxon_1.DateTime.now()
                .set({
                year: dateParam.year,
                month: dateParam.month,
                day: dateParam.day
            })
                .startOf('day');
        }
        else {
            return luxon_1.DateTime.now().startOf('day');
        }
    }, [dateInput, dateParamISOString]);
    let startWeek = null;
    let endWeek = null;
    if (selectedDate.weekday >= 1 && selectedDate.weekday <= 4) {
        startWeek = selectedDate.startOf('week').minus({ days: 1 }).toUTC().toISO();
        endWeek = selectedDate.endOf('week').minus({ days: 2 }).toUTC().toISO();
    }
    else {
        startWeek = selectedDate.startOf('week').plus({ days: 3 }).toUTC().toISO();
        endWeek = selectedDate.endOf('week').plus({ days: 1 }).toUTC().toISO();
    }
    const timeRange = {
        start: selectedDate.startOf('month').minus({ days: 6 }).toUTC().toISO(),
        end: selectedDate.endOf('month').plus({ days: 6 }).toUTC().toISO(),
        startWeek,
        endWeek
    };
    return {
        selectedDate,
        timeRange
    };
};
exports.useDateQueryParams = useDateQueryParams;
